import { Component, Input, OnInit } from '@angular/core';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { filterBy, orderBy, SortDescriptor } from '@progress/kendo-data-query';
import { ClientLookupParamsModel } from 'app/modules/settings/interfaces/client-lookup';
import { ClientLookupService } from 'app/modules/settings/services/client-lookup.service';
import { MappingType } from '../../interfaces/mapping-type';
import { NoDataActionType, NoDataSourceType, NoDataTypes } from '../../interfaces/no-data';
import { ToastService } from '../../services/toast.service';

@Component({
    selector: 'mapping-table',
    templateUrl: './mapping-table.component.html',
    styleUrls: ['./mapping-table.component.scss']
})
export class MappingTableComponent implements OnInit {
    // NOTE: Mapping table not fully component agnostic yet
    @Input() mappingDescription: string;
    @Input() mappingData: any[];
    @Input() mappingTypes: MappingType[];
    @Input() mappingSort: SortDescriptor[];
    @Input() mappingTitle: string;
    @Input() loading: boolean = false;

    mappingSearchTerm: string;
    filteredMappings: MappingType[];
    saveBtnDisabled: boolean = true;
    tableData: { data: any, total: any };
    noDataType: NoDataTypes;
    pageSize = 10;
    skip = 0;

    constructor(private clientLookupService: ClientLookupService,
                private toastService: ToastService) { }

    ngOnInit() {
        this.noDataType = {
            action: NoDataActionType.pageStart,
            searchTerm: '',
            componentTitle: this.mappingTitle,
            inputSource: NoDataSourceType.listOfEntities,
        };
        this.updateGrid();
    }

    ngOnChanges() {
        if(this.mappingSearchTerm && this.mappingSearchTerm.length != 0) {
            this.filterMappings()
        } else {
            this.filteredMappings = null;
        }
        this.updateGrid();
    }

    updateGrid() {
        if(this.mappingData != null) {
            let orderedData = orderBy(
                this.filteredMappings ? this.filteredMappings : this.mappingData, 
                this.mappingSort);
            this.tableData = {
                data: orderedData?.slice(this.skip, this.skip + this.pageSize),
                total: orderedData.length
            };
        }
    } 

    pageChange({ skip, take }: PageChangeEvent): void {
        this.skip = skip;
        this.pageSize = take;
        this.updateGrid();
    }

    sortChange(sort: SortDescriptor[]): void {
        this.mappingSort = sort;
        this.updateGrid();
    }

    mappingChangeHandler(changedMapping: any) {
        this.mappingData.find(
            (mapping) => mapping.clientTag === changedMapping.clientTag
        ).isDirty = true;
        this.saveBtnDisabled = false;
    }

    filterMappings() {
        this.filteredMappings = filterBy(this.mappingData, {
            logic: 'or',
            filters: [
                {
                    field: 'clientTag',
                    operator: 'contains',
                    value: this.mappingSearchTerm,
                    ignoreCase: true,
                },
                {
                    field: 'lookupValue',
                    operator: 'contains',
                    value: this.mappingSearchTerm,
                    ignoreCase: true,
                },
            ],
        });
        let orderedData = orderBy(this.filteredMappings, this.mappingSort);
        this.tableData = {
            data: orderedData.slice(this.skip, this.skip + this.pageSize),
            total: orderedData.length,
        };
    }

    // TODO: Make this more dynamic, pass in a callback function from a Input() parameter
    submitChanges() {
        let changedMappings: ClientLookupParamsModel[] = this.mappingData
            .filter((mapping) => mapping.isDirty)
            .map((mapping) => {
                return {
                    clientTag: mapping.clientTag,
                    lookupValueKey: +mapping.typeKey,
                    lookupDataTypeAbbv: null
                }
            });

        this.clientLookupService.submitChanges(changedMappings).subscribe(
            (data) => {
                this.saveBtnDisabled = true;
                this.toastService.success(`Updated ${this.mappingTitle} mappings successfully`)
            },
            (error) => {
                throw new Error(error);
            }
        )
    }
}
